const setSummary = (state, summary) => {
  Object.assign(state, { summary })
}

const setClinicalBackgrounds = (state, clinicalBackgrounds) => {
  Object.assign(state, { clinicalBackgrounds })
}

const setTriage = (state, triage) => {
  Object.assign(state, { triage })
}

const setTimeline = (state, timeline) => {
  Object.assign(state, { timeline })
}

const setLiteProfile = (state, liteProfile) => {
  Object.assign(state, { liteProfile })
}

export default {
  setTriage,
  setSummary,
  setTimeline,
  setClinicalBackgrounds,
  setLiteProfile
}
